











































































import { Component, Vue } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import { Tab, Tabs, Loading } from "vant";
import request from "../../../api/index";
import NewsItem from "@/components/NewsItemNA.vue";
import AppPrompt from "@/components/NewsAppProCmptNA.vue";
import { findNameByWechatAppid } from "@/common/Utils";
import { wxChatShare } from "@/common/wechat";
@Component({
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    NewsItem,
    Loading,
    AppPrompt
  }
})
export default class ColumnDetail extends Base {
  public active = 0;
  public request = new request();
  public appId = "";
  public parentColumn: any = [];
  public sonColumn: any = [];
  public finished = false;
  public tabColumn: any = [];
  newsList: any = [];
  newsArr: any = [];
  wxAppId: any = "";
  columnId: string = "";
  // 下拉刷新
  onRefresh(done: any) {
    this.newsList = [];
    this.getnewsList(this.tabColumn[this.active].id);
    done();
  }
  // 上拉加载
  onLoad(done: any) {
    this.getnewsList(this.tabColumn[this.active].id);
    done();
  }
  // 改变tab
  changetab(number: number) {
    this.newsList = [];
    this.finished = false;
    this.getnewsList(this.tabColumn[number].id);
  }
  async mounted() {
    const shareInfo = await this.request.getNananShareInfo();

    this.appId = (this.$route.query.appId as string) || "";
    await this.getShareInfo(this.appId);
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    this.columnId = (this.$route.query.columnId as string) || "";
    const { title, shareDes, jzUrl, shareImg, topColCount } = shareInfo[
      this.columnId
    ];
    document.title = title;
    wxChatShare(title, shareDes, jzUrl, shareImg);
    this.request.getColumns(this.appId, this.columnId, true, "11").then(res => {
      // 返回的第一个是父栏目
      this.parentColumn = res.data.dataList.splice(0, 1);
      // 根据配置json topColCount 取中间展示栏目
      this.sonColumn = res.data.dataList.slice(0, topColCount);
      // 剩下的tab
      this.tabColumn = res.data.dataList.slice(topColCount);
      this.tabColumn.length && this.getnewsList(this.tabColumn[0].id);
    });
  }
  // 获取新闻列表
  async getnewsList(columnId: string) {
    let res = [];
    if (this.newsList.length) {
      res = await this.request.getnewsList({
        appId: this.appId,
        isCarousel: false,
        columnId,
        lastId: this.newsList[this.newsList.length - 1].id,
        lastSortNo: this.newsList[this.newsList.length - 1].sortNo,
        lastOnlineTime: this.newsList[this.newsList.length - 1].onlineTime
      });
      this.newsList = [...this.newsList, ...res.data.news];
    } else {
      res = await this.request.getnewsList({
        appId: this.appId,
        isCarousel: false,
        columnId
      });
      this.newsList = res.data.news;
    }
    if (res.data.news.length == 0) {
      this.finished = true;
    } else {
      this.finished = false;
    }
  }
  newItemClick(item: any) {
    window.open(item.url);
  }
  toNewsList(id: number) {
    window.open(`/newslist/news-list?appId=${this.appId}&columnId=${id}`);
  }
}
